import {filter} from 'lodash'
import homeIcon from '../../../assets/images/home-icon.png'
import chartIcon from '../../../assets/images/chart-icon.png'
import coursesIcon from '../../../assets/images/courses-icon.png'
import knowledgeCenterIcon from '../../../assets/images/knowlage-center-icon.png'
import usersIcon from '../../../assets/images/users-icon.png'
import settingsIcon from '../../../assets/images/settings-icon.png'
import beeIcon from '../../../assets/images/icon-bee.png'
import {FeatureFlags} from "../../../Utils/Constants";

/**
 * Builds the list of side menu buttons the user can see
 * @param {object} params - The function parameters container object
 * @param {number} params.adminOrgsLength - Number of organizations the user manages
 * @param {boolean} params.isSuperAdmin - Whether the user is a super admin
 * @param {boolean} params.isCompanyAdmin - Whether the user is a company admin
 * @param {boolean} [params.hasUserPendingApprovals] - Whether the user has approver access
 * @param {boolean} [params.isCourseApprover] - Whether the user can approve course attendance
 * @param {boolean} [params.isDocumentApprover] - Whether the user can approve documents
 * @param {boolean} [params.hasExpiringPartnerSecret] - Whether the Partners button shows as an alert
 * @param {object} params.featureFlags - The company feature flags
 * @returns {Array<object>} The menu buttons
 */
export const getMenuButtons = ({adminOrgsLength, isSuperAdmin, isCompanyAdmin, hasUserPendingApprovals = false, isCourseApprover = false, isDocumentApprover = false, hasExpiringPartnerSecret = false, featureFlags}) => {
    const hasAdminOrgs = adminOrgsLength && adminOrgsLength > 0
    const isAdmin = hasAdminOrgs || isCompanyAdmin
    const isApproverOnly = !isAdmin && hasUserPendingApprovals

    // Determine the default learning management link for approver-only users
    const getLearningManagementLink = () => {
        if (!isApproverOnly) {
            return '/learningManagement/users';
        }

        // Priority 1: Pending Approvals (if user is document approver and feature flag is enabled)
        if (isDocumentApprover && featureFlags?.[FeatureFlags.UPLOAD_DOCUMENT]) {
        return '/learningManagement/pendingApprovals';
        }

        // Priority 2: Course Attendance (if user is course approver and feature flags are enabled)
        const hasCourseFF = featureFlags?.[FeatureFlags.FRONTAL_COURSE] || featureFlags?.[FeatureFlags.ONLINE_COURSE];
        if (isCourseApprover && hasCourseFF) {
            return '/learningManagement/courseAttendance';
        }

        // Fallback to users
        return '/learningManagement/users';
    };

    let menuItems = [
        {
            nameKey: 'menuItems.home',
            icon: (selected) => <img src={homeIcon} alt=""/>,
            link: '/home',
            detectSelected: ['home'],
            show: true,

        },
        {
            nameKey: 'menuItems.learningCenter',
            icon: (selected) => <img src={coursesIcon} alt=""/>,
            link: '/learningCenter/myContent',
            detectSelected: ['learningCenter'],
            show: !isSuperAdmin
        },
        {
            // A patch for home center company
            nameKey: featureFlags?.[FeatureFlags.OPERATION_MODE] ? 'menuItems.operation' : 'menuItems.knowledgeCenter',
            icon: (selected) => <img src={knowledgeCenterIcon} alt=""/>,
            link: '/knowledgeCenter',
            detectSelected: ['knowledgeCenter'],
            show: !isSuperAdmin,
            requiredFeatureFlags: [FeatureFlags.KNOWLEDGE_CENTER]
        },
        {
            nameKey: 'menuItems.learningManagement',
            icon: (selected) => <img src={beeIcon} alt=""/>,
            link: getLearningManagementLink(),
            detectSelected: ['learningManagement'],
            show: (hasAdminOrgs || isCompanyAdmin || hasUserPendingApprovals) && !isSuperAdmin
        },
        {
            nameKey: 'menuItems.reports',
            icon: (selected) => <img src={chartIcon} alt=""/>,
            link: '/reports/dashboard',
            detectSelected: ['reports'],
            show: (hasAdminOrgs || isCompanyAdmin) && !isSuperAdmin
        },
        {
            nameKey: 'menuItems.settings',
            icon: (selected) => <img src={settingsIcon} alt=""/>,
            link: '/settings/general',
            detectSelected: ['settings'],
            show: (hasAdminOrgs || isCompanyAdmin) && !isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.customers',
            icon: (selected) => <img src={usersIcon} alt=""/>,
            link: '/nihol/customers',
            detectSelected: ['nihol/customers'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.courses',
            icon: (selected) => <img src={beeIcon} alt=""/>,
            link: '/nihol/courses',
            detectSelected: ['nihol/courses'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.users',
            icon: (selected) => <img src={usersIcon} alt=""/>,
            link: '/nihol/users',
            detectSelected: ['nihol/users'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.organizations',
            icon: (selected) => <img src={usersIcon} alt=""/>,
            link: '/nihol/organizations',
            detectSelected: ['nihol/organizations'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.partners',
            icon: (selected) => <img src={usersIcon} alt=""/>,
            link: '/nihol/partners',
            detectSelected: ['nihol/partners'],
            show: isSuperAdmin,
            isAlert: hasExpiringPartnerSecret
        },
        {
            nameKey: 'menuItems.superAdmin.dashboards',
            icon: (selected) => <img src={usersIcon} alt=""/>,
            link: '/nihol/dashboards/companies',
            detectSelected: ['nihol/dashboards'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.assets',
            icon: (selected) => <img src={beeIcon} alt=""/>,
            link: '/nihol/assets',
            detectSelected: ['nihol/assets'],
            show: isSuperAdmin
        },
        {
            nameKey: 'menuItems.superAdmin.courseTemplates',
            icon: (selected) => <img src={beeIcon} alt=""/>,
            link: '/nihol/courseTemplates',
            detectSelected: ['nihol/courseTemplates'],
            show: isSuperAdmin
        }
    ]
    return filter(menuItems, (item) => {
        if(item.requiredFeatureFlags){
            const hasAllFeatureFlags = item.requiredFeatureFlags.every((featureFlag) => featureFlags?.[featureFlag] || false)
            return hasAllFeatureFlags && item.show
        }
        else {
            return item.show
        }
    })
}
